import _export from '../internals/export.js';
import regexpExec from '../internals/regexp-exec.js';

var $ = _export;
var exec = regexpExec; // `RegExp.prototype.exec` method
// https://tc39.es/ecma262/#sec-regexp.prototype.exec

$({
  target: 'RegExp',
  proto: true,
  forced: /./.exec !== exec
}, {
  exec: exec
});
